import React, { useContext } from 'react';
import { NavContext } from 'Context/nav-context';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { chevronRightIcon, LoggedInStatus } from 'Data/constants';
import Icon from '@lds/icon';
import { formatLink } from '@/utils';
import { useDetermineBanner, useDetermineEnvironment } from '@/hooks';

// styles
import styles from '../mobile-top-nav.module.scss';

interface MobileAccountBarProps {
  setCurrentIndex?: React.Dispatch<number>;
}

const MobileAccountBar: React.FC<MobileAccountBarProps> = ({ setCurrentIndex }) => {
  const {
    category: {
      ['L0']: [, setL0],
    },
    user: {
      ['userStatus']: [userStatus],
      ['loginURL']: [loginURL],
    },
  } = useContext(NavContext);

  const { formatMessage } = useIntl();
  const isPhxBanner = useDetermineBanner();
  const env = useDetermineEnvironment();

  const isUserAnonymous = userStatus === LoggedInStatus.ANONYMOUS;

  return (
    <>
      <li className={clsx(styles.navItem, styles.myAccount)}>{formatMessage({ id: 'myAccount' })}</li>
      <li className={styles.navItemL0}>
        <a
          className={styles.navSignIn}
          href={formatLink(loginURL, isPhxBanner, env)}
          onClick={(e) => {
            if (!isUserAnonymous) {
              e.preventDefault();
              setL0('accountLinks');
              setCurrentIndex?.(1);
            }
          }}
        >
          {formatMessage({ id: isUserAnonymous ? 'signIn' : 'myAccount' })}
          {isUserAnonymous ? null : (
            <Icon
              classes={styles.chevronRight}
              alt={formatMessage({ id: 'rightArrow' })}
              src={chevronRightIcon}
              width={8}
              height={8}
            />
          )}
        </a>
      </li>
      <li className={styles.navItemL0}>
        <a href={formatLink('/favourite', isPhxBanner, env)} className={styles.favoritesLink}>
          {formatMessage({ id: 'favorites' })}
        </a>
      </li>
      {!isUserAnonymous ? (
        <li className={styles.navItemL0}>
          <a href="/previous-purchases">{formatMessage({ id: 'shopPreviousPurchases' })}</a>
        </li>
      ) : null}
    </>
  );
};

export default MobileAccountBar;
